import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["plusButton", "minusButton"]

  connect() {
    this.numberInput = this.element.querySelector("input")

    this.plusButtonTarget.addEventListener("click", () =>
      this.increment(),
    )
    this.minusButtonTarget.addEventListener("click", () =>
      this.decrement(),
    )
  }

  increment() {
    const value = parseInt(this.numberInput.value) || 0
    this.numberInput.value = value + 1
    this.ensureMinimum()
    this.fireChange()
  }

  decrement() {
    const value = parseInt(this.numberInput.value) || 0
    this.numberInput.value = value - 1
    this.ensureMinimum()
    this.fireChange()
  }

  // assume we won't accept less than one
  ensureMinimum() {
    if (parseInt(this.numberInput.value) < (parseInt(this.numberInput.min) || 1)) {
      this.numberInput.value = this.numberInput.min || 1
    }
  }

  // notify
  fireChange() {
    const event = new CustomEvent("change", {bubbles: true})
    this.numberInput.dispatchEvent(event)
  }
}
